

/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import CursoConstanciaList from './CursoConstanciaList';
import {bindActionCreators} from 'redux';
import * as cursoconstanciaActions from '../../actions/cursoconstanciaActions';
import * as paginaActions from '../../actions/paginaActions';
import toastr from 'toastr';
import ManageList from '../common/ManageList';
import { Segment} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import {getMargenes} from '../../util/'; 
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';


class ManageCursoConstanciaList extends ManageList  {
    constructor(props, context) {
		
		super(props, context);
        this.state={
            errors:{},
            strings:[],
            showActivos:true,
            filtrosCombo:{},
            permisos:{}
		};
	}

	componentDidMount(){
       
		window.scrollTo(0, 0);
       let pageInfo={
            page:'CursoConstancia',
            idioma:this.props.idioma 
         };
  this.props.showSidebarIzquierdaActions.sidebarIzquierda(true); 
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{
           this.setState({"permisos":pageInfoResponse.permisos,
                         "strings":pageInfoResponse.strings});
       })
        .catch(error=>{
          toastr.error(error);
        }); 
		this.inicializa();
	}
        
  
    
    render() {
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 
		return (
            <Segment  style={margenes}>
                  
                <CursoConstanciaList
                    strings={this.props.strings}
                    cursoconstancia={this.props.listado.content}
                    activePage={this.props.listado.paginaActual+1}
                    handleSelectPagination={this.handleSelectPagination}
                    totalPages={this.props.listado.totalPages}
                    handleChange= {this.handleChangeFiltro}
                    filtro={this.state.filtro}
                    onFiltrarInformacion={this.onFiltrarInformacion}
                    filtroActivo={this.props.listado.filtroActivo}
                    filtroActual={this.props.listado.filtroActual}
                    onDesactivarFiltro={this.onDesactivarFiltro}
                    confirmarBorrado={this.confirmarBorrado}
                    onShowModalBorrar={this.onShowModalBorrar}
                    onShowModalActivar={this.onShowModalActivar}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    handleChangeFiltro= {this.handleChangeFiltro}
                    handleChangeActivos={this.handleChangeActivos}
                    showActivos={this.props.listado.showActivos}
                    color={this.props.color}
					 form={this.props.form}
                    permisos={this.state.permisos}

                />
            
                <ModalSiNo
                    showModal={this.state.showModalBorrar}
                    closeModal={this.oncloseModal}
                    borrar={this.borrar}
                    icono={"trash"}
                    texto={"Esta seguro que desea eliminar este registro de forma permanente?"}
                    titulo={this.state.strings?this.state.strings["CursoConstancia"]:""}
                />
            
                <ModalSiNo
                    showModal={this.state.showModalActivar}
                    closeModal={this.oncloseModal}
                    borrar={this.activar}
                    icono={"exchange"}
                    texto={"Esta seguro que desea cambiar el esatus del registro?"}
                    titulo={this.state.strings?this.state.strings["CursoConstancia"]:""}
                 />

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {
         listado:state.cursoconstancia,
         showSidebarIzquierda: state.showSidebarIzquierda,
  sidebarIzquierda: state.sidebarIzquierda, 
          ajaxCallInProgress:state.ajaxCallInProgress,
         color:state.color,
		  permisos:state.permisos,
strings:state.strings, 
         form:state.form,
user:state.user, 
idioma:state.idioma,
    }

}

function mapDispatchToProps(dispatch){

	return {   
  showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
paginaActions: bindActionCreators(paginaActions, dispatch),
			listadoActions: bindActionCreators(cursoconstanciaActions, dispatch),
			load:bindActionCreators(cursoconstanciaActions.getCursoConstanciaList, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageCursoConstanciaList);